import { useQuery } from '@tanstack/react-query';
import requestService from '~/services/requestsService/requests.service';
import { CountriesEntity } from '@bitecritic-api/src/countries/countries.entity';

const fetchCountries = async (): Promise<CountriesEntity[]> => {
  const response = await requestService.fetch<CountriesEntity[]>('/countries');
  return response ?? [];
};

export const useCountriesService = () => {
  return useQuery({
    queryKey: ['countries'],
    queryFn: fetchCountries,
  });
};

const countriesService = {
  fetchCountries,
};

export default countriesService; 